import EndPointConfig from "../../models/api/endPointConfig";

const controller = "Referrals";

/// Define all EndPoints for Position section.
export const ReferralsEP: EndPointConfig[] = [
  new EndPointConfig().setMethod("GET").setController(controller).setActionName("amounts").setAlias("GetAmountsReferral"),
  new EndPointConfig().setMethod("PATCH").setController(controller).setActionName("amounts").setAlias("ChangeAmountReferral"),
  new EndPointConfig().setMethod("GET").setController(controller).setActionName("status").setAlias("GetStatusReferral"),
  new EndPointConfig().setMethod("PATCH").setController(controller).setActionName("status").setAlias("ChangeStatusReferral"),
  new EndPointConfig().setMethod('DELETE').setController(controller).setPattern('amounts/{id}').setAlias('DeletetReferralAmount'),
];
